import { HiOutlineMail } from "react-icons/hi";
// eslint-disable-next-line no-unused-vars
import { DownloadOutlined } from "@ant-design/icons";
// eslint-disable-next-line no-unused-vars
import {
  HiOutlineLockClosed,
  HiOutlineClipboardDocumentList,
  HiOutlineSquares2X2,
} from "react-icons/hi2";
import {
  LuFileChartColumnIncreasing,
  LuMessageCircleQuestion,
  LuPackageSearch,
} from "react-icons/lu";
import { PiSwap } from "react-icons/pi";
import { RiExchangeBoxLine } from "react-icons/ri";
import {
  TbTransfer,
  TbTransferIn,
  TbTransferOut,
  TbTruck,
  TbTruckReturn,
} from "react-icons/tb";
import { useSelector } from "react-redux";

const routeConfigParent = [
  {
    id: "Dashboards",
    title: "Overview",
    messageId: "sidebar.application",
    type: "group",
    children: [
      {
        id: "dashboard",
        title: "Dashboard",
        messageId: "menu.dashboard",
        icon: <HiOutlineSquares2X2 size={18} strokeWidth={1.75} />,
        path: "/dashboard",
      },
      {
        id: "jobs-tracker",
        title: "Jobs Tracker Dashboard",
        messageId: "menu.jobs",
        icon: <HiOutlineClipboardDocumentList />,
        path: "/jobs-tracker",
        visible: "Manager",
      },
      {
        id: "transactions",
        title: "Transactions",
        messageId: "menu.tickets",
        icon: <RiExchangeBoxLine />,
        type: "collapse",
        visible: "Manager",
        children: [
          {
            id: "allot-order",
            title: "Allot Order",
            messageId: "menu.po",
            icon: <TbTruck />,
            path: "/allot-order",
          },
          {
            id: "return-order",
            title: "Return Order",
            messageId: "menu.ro",
            icon: <TbTruckReturn />,
            path: "/return-order",
          },
          {
            id: "damage-swap",
            title: "Damage Swap",
            messageId: "menu.ds",
            icon: <PiSwap />,
            path: "/damage-swap",
          },
          {
            id: "transfer-out",
            title: "Transfer Out",
            messageId: "menu.po",
            icon: <TbTransferOut />,
            path: "/transfer-out",
          },
          {
            id: "transfer-in",
            title: "Transfer In",
            messageId: "menu.po",
            icon: <TbTransferIn />,
            path: "/transfer-in",
          },
          {
            id: "bulk-transfer-in",
            title: "Bulk Transfer IN",
            messageId: "menu.bulk-transfers-in",
            icon: <TbTransfer />,
            path: "/bulk-transfer-in",
          },
          {
            id: "bulk-transfer-out",
            title: "Bulk Transfer Out",
            messageId: "menu.bulk-transfers-out",
            icon: <TbTransfer />,
            path: "/bulk-transfer-out",
          },
        ],
      },
      {
        id: "layouts",
        title: "Layouts",
        messageId: "menu.layouts",
        icon: (
          <span className="material-symbols-outlined" style={{ fontSize: 20 }}>
            table_view
          </span>
        ),
        path: "/layouts",
      },
      {
        id: "reports",
        title: "Reports",
        messageId: "menu.reports",
        icon: <LuFileChartColumnIncreasing />,
        path: "/reports",
      },

      {
        id: "settings",
        title: "Settings",
        messageId: "menu.settings",
        icon: (
          <span className="material-symbols-outlined" style={{ fontSize: 20 }}>
            settings
          </span>
        ),
        type: "collapse",
        children: [
          {
            id: "changepassword",
            title: "Change Password",
            messageId: "menu.cp",
            icon: <HiOutlineLockClosed />,
            path: "/changepassword",
          },
          {
            id: "subscription",
            title: "Reports Subscription",
            messageId: "menu.sub",
            icon: <HiOutlineMail />,
            path: "/subscription",
          },
          {
            id: "user-requisition",
            title: "User Requisition",
            messageId: "menu.userReq",
            icon: <HiOutlineClipboardDocumentList />,
            path: "/user-requisition",
          },
        ],
      },
      {
        id: "track-order",
        title: "Track Order",
        messageId: "menu.track",
        icon: <LuPackageSearch />,
        path: "/track-order",
      },
      {
        id: "Help&Support",
        title: "Help & Support",
        messageId: "menu.track",
        icon: <LuMessageCircleQuestion />,
        path: "/Help&Support",
      },
    ],
  },
];

// Move everything into a hook
export function useRouteConfigParent() {
  const { currentCompany } = useSelector((state) => state.companies);
  const lob =
    currentCompany?.lineOfBusiness || localStorage.getItem("lineOfBusiness");

  // Filter out "bulk-transfer-in" and "bulk-transfer-out" if lob is "02"
  const filteredRouteConfigParent =
    lob === "02"
      ? routeConfigParent.map((group) => ({
          ...group,
          children: group.children.map((item) => ({
            ...item,
            children: item.children
              ? item.children.filter(
                  (child) =>
                    !["bulk-transfer-in", "bulk-transfer-out"].includes(
                      child.id
                    )
                )
              : item.children,
          })),
        }))
      : routeConfigParent;
  return filteredRouteConfigParent;
}
